// frontend/src/modules/public/components/LeadRapidoForm.jsx
import React, { useState } from 'react';
import { FaCheck, FaWhatsapp } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function LeadRapidoForm() {
  const [formData, setFormData] = useState({
    nome_completo: '',
    email: '',
    telefone: '',
    mensagem: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/leads/abertura`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          atividade: 'Contabilidade Online - Interesse',
          regime_desejado: 'NAO_SEI'
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao enviar');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ============================================
  // SUCESSO
  // ============================================
  if (success) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '30px 20px',
        backgroundColor: '#e8f5e9',
        borderRadius: '12px',
        border: '2px solid #28a745'
      }}>
        <div style={{ fontSize: '50px', marginBottom: '15px' }}>🎉</div>
        <h4 style={{
          color: '#2e7d32',
          marginBottom: '10px',
          marginTop: 0,
          fontSize: '20px'
        }}>
          Recebemos sua solicitação!
        </h4>
        <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '20px' }}>
          Entraremos em contato em até 24 horas úteis.
        </p>
        
        <a
          href={`https://wa.me/5511999999999?text=Olá! Acabei de preencher o formulário no site e gostaria de falar sobre contabilidade online.`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 24px',
            backgroundColor: '#25D366',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '14px'
          }}
        >
          <FaWhatsapp /> Falar agora no WhatsApp
        </a>
      </div>
    );
  }

  // ============================================
  // FORMULÁRIO
  // ============================================
  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '14px',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    outline: 'none'
  };

  const handleFocus = (e) => {
    e.target.style.borderColor = '#4a90e2';
    e.target.style.boxShadow = '0 0 0 3px rgba(74,144,226,0.1)';
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = '#ddd';
    e.target.style.boxShadow = 'none';
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && (
        <div style={{
          backgroundColor: '#ffebee',
          color: '#c62828',
          padding: '10px',
          borderRadius: '6px',
          marginBottom: '15px',
          fontSize: '13px'
        }}>
          ❌ {error}
        </div>
      )}

      <div style={{ marginBottom: '15px' }}>
        <label style={{
          display: 'block',
          marginBottom: '6px',
          fontSize: '13px',
          fontWeight: '500',
          color: '#495057'
        }}>
          Nome completo *
        </label>
        <input
          type="text"
          name="nome_completo"
          value={formData.nome_completo}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required
          placeholder="Digite seu nome"
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{
          display: 'block',
          marginBottom: '6px',
          fontSize: '13px',
          fontWeight: '500',
          color: '#495057'
        }}>
          Email *
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required
          placeholder="seu@email.com"
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label style={{
          display: 'block',
          marginBottom: '6px',
          fontSize: '13px',
          fontWeight: '500',
          color: '#495057'
        }}>
          WhatsApp / Telefone *
        </label>
        <input
          type="tel"
          name="telefone"
          value={formData.telefone}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required
          placeholder="(11) 99999-9999"
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '6px',
          fontSize: '13px',
          fontWeight: '500',
          color: '#495057'
        }}>
          O que você precisa?
        </label>
        <select
          name="mensagem"
          value={formData.mensagem}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          style={inputStyle}
        >
          <option value="">Selecione...</option>
          <option value="Quero trocar de contador">Quero trocar de contador</option>
          <option value="Quero abrir uma empresa">Quero abrir uma empresa</option>
          <option value="Quero encerrar uma empresa">Quero encerrar uma empresa</option>
          <option value="Preciso de contabilidade online">Preciso de contabilidade online</option>
          <option value="Outro">Outro</option>
        </select>
      </div>

      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          padding: '14px',
          backgroundColor: loading ? '#6c757d' : '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          transition: 'background 0.2s, transform 0.2s'
        }}
        onMouseEnter={(e) => {
          if (!loading) {
            e.currentTarget.style.background = '#218838';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }
        }}
        onMouseLeave={(e) => {
          if (!loading) {
            e.currentTarget.style.background = '#28a745';
            e.currentTarget.style.transform = 'translateY(0)';
          }
        }}
      >
        <FaCheck /> {loading ? 'Enviando...' : 'Quero ser contatado'}
      </button>

      <p style={{
        textAlign: 'center',
        fontSize: '11px',
        color: '#adb5bd',
        marginTop: '12px',
        marginBottom: 0
      }}>
        🔒 Seus dados estão seguros. Não enviamos spam.
      </p>
    </form>
  );
}

export default LeadRapidoForm;